import { render } from "./HomeView.vue?vue&type=template&id=6fba932a&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=6fba932a&scoped=true&lang=css"

import exportComponent from "E:\\软件项目\\深圳官网\\official-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fba932a"]])

export default __exports__